import {
  Cached,
  Mapper,
  ChainedMapper,
  FirestoreEntity,
  getFirestoreEntityVersionFn,
  VersionMapper,
} from '../@harmony';
import { UserEntity, AnyUserEntityVersion, UserEntityToUserMapper, User } from '.';

export abstract class AuthCommonProvider {
  abstract provideUserEntityVersionsMapper(): Mapper<
    FirestoreEntity<AnyUserEntityVersion>,
    FirestoreEntity<UserEntity>
  >;
  abstract provideUserEntityToUserMapper(): Mapper<FirestoreEntity<AnyUserEntityVersion>, User>;
}

export class AuthCommonDefaultProvider implements AuthCommonProvider {
  @Cached()
  public provideUserEntityVersionsMapper(): Mapper<
    FirestoreEntity<AnyUserEntityVersion>,
    FirestoreEntity<UserEntity>
  > {
    return new VersionMapper(getFirestoreEntityVersionFn, []);
  }

  @Cached()
  public provideUserEntityToUserMapper(): Mapper<FirestoreEntity<AnyUserEntityVersion>, User> {
    return new ChainedMapper([
      this.provideUserEntityVersionsMapper(),
      new UserEntityToUserMapper(),
    ]);
  }
}
